import { IUpdateLiveClassVote } from '@sdk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { useTranslation } from 'react-i18next';

import { sdk } from '@/services';

const LiveClassVoteService = sdk.getService('LiveClassVoteService');

export const useMutateLiveClassVote = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { t } = useTranslation('DefaultTranslations');

  const onSuccess = () => queryClient.invalidateQueries({ queryKey: ['live-class-vote'] });

  const { mutate: voteLiveClass, isPending: isVoting } = useMutation({
    mutationFn: (vote: IUpdateLiveClassVote) => LiveClassVoteService.voteLiveClass(vote),
    onSuccess: () => {
      onSuccess();
      message.success(t('LIVE_CLASS_VOTE_SUCCESS'));
    }
  });

  return {
    voteLiveClass,
    isVoting
  };
};
